import AudioPlayerDetail from "./audio-player-detail";
import Swiper, {Navigation} from "swiper";

Swiper.use([Navigation]);

export default class AudioPlayerSlider {
    protected playlist: AudioPlayerDetail[] = [];
    protected slider;

    constructor(protected container) {
        const sliderNode = this.container.find('.slider');
        this.container.find('.audio-player-detail').each((id, el) => {
            this.playlist.push(new AudioPlayerDetail($(el), $(el)));
        });

        this.slider = new Swiper(sliderNode.get(0), {
            slidesPerView: 1,
            navigation: {
                nextEl: this.container.find('.btn-next').get(0),
                prevEl: this.container.find('.btn-prev').get(0),
                hiddenClass: 'd-none',
                disabledClass: 'd-none',
            }
        });

        this.slider.on('slideChange', this.stopAll.bind(this));
    }

    stopAll() {
        this.playlist.filter(player => player.pause());
    }
}